import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="mb-4">
          <Col lg={4} md={6} className="mb-4 mb-md-0">
            <h5>जीवन आधार</h5>
            <p>
              विमा, आर्थिक सेवा आणि समाजासाठी आधार देत आपले भविष्य सुरक्षित करण्यासाठी आम्ही कटिबद्ध आहोत.
            </p>
            <div className="social-icons">
              <a href="#" className="me-3"><FontAwesomeIcon icon={faFacebook} size="lg" /></a>
              <a href="#" className="me-3"><FontAwesomeIcon icon={faTwitter} size="lg" /></a>
              <a href="#" className="me-3"><FontAwesomeIcon icon={faLinkedin} size="lg" /></a>
              <a href="#" className="me-3"><FontAwesomeIcon icon={faInstagram} size="lg" /></a>
            </div>
          </Col>
          <Col lg={4} md={6} className="mb-4 mb-md-0">
            <h5>त्वरित लिंक</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="/">मुख्यपृष्ठ</a></li>
              <li className="mb-2"><a href="/insurance">विमा सेवा</a></li>
              <li className="mb-2"><a href="/foundation">फाउंडेशन</a></li>
              <li className="mb-2"><a href="/finance">आर्थिक सेवा</a></li>
              <li className="mb-2"><a href="/about">संस्थापकांची माहिती</a></li>
              <li className="mb-2"><a href="/contact">संपर्क</a></li>
            </ul>
          </Col>
          <Col lg={4} md={12}>
            <h5>संपर्क माहिती</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                जीवन आधार विमा सेवा केंद्र,टेंभुर्णी,413211,महाराष्ट्र
              </li>
              <li className="mb-2">
                <FontAwesomeIcon icon={faPhone} className="me-2" />
                +91 9881665741
              </li>
              <li className="mb-2">
                <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                kishorsalgar55100@gmail.com
              </li>
            </ul>
          </Col>
        </Row>
        <hr className="mt-4 mb-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }} />
        <Row>
          <Col className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} जीवन आधार. सर्व हक्क राखीव.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
